<footer
  [ngStyle]="{
    'background-color': background() || '#222',
  }"
  [style.position]="position()"
>
  <span [ngStyle]="{ color: text() || '#ffffff' }"
    >Copyright &copy; {{ currentYear }} TheLightupHub. All rights
    reserved.</span
  >
  <span class="grouped-content">
    <span
      [ngStyle]="{ color: text() || '#ffffff' }"
      class="privacy-policy"
      (click)="openPrivacyPolicy()"
      >Privacy Policy</span
    >
    <span>|</span>
    <span
      [ngStyle]="{ color: text() || '#ffffff' }"
      class="terms-and-contditions"
      (click)="openTCs()"
      >Terms & Conditions</span
    >
  </span>

  @if (showPaymentImages()) {
    <div class="payment-images">
      <div class="image-badges">
        <img src="assets/images/secure_payments gold star.png" />
        <img src="assets/images/satisfaction star.png" />
      </div>
      <img src="assets/images/secure-stripe-payment-logo.png" />
    </div>
  }
</footer>
